export default __webpack_public_path__ + "static/media/phuctinhqn1.88dd1c0d.png";